import { useEffect, useRef, useState } from "react";
import { Fetch } from "../shared/Fetch";
import { Toast } from "primereact/toast";

export const Unsubscribe = () => {
    const [message, setMessage] = useState("Processing your request...");
    const [email, setEmail] = useState("");
    const toast = useRef<any>(null);

    const unsubscribeForEmail = async (email: string, mass?: number, req_ID?: string | null) => {
        const response = await Fetch("Consultant_Mast/unsubscribe", "GET", null, ((mass !== undefined && mass !== null && mass > 0) ? `passKey=${"12AMD1_" + email + "_GF75A"}&mass=${mass}&reqID=${req_ID !== null ? req_ID : ""}` : `passKey=${"12AMD1_" + email + "_GF75A"}`), toast);
        if (response) {
            setMessage("You have successfully unsubscribed.");
            window.close();
        }
    }

    // Call API on page load
    useEffect(() => {
        // Extract email from URL query param (e.g., ?email=test@example.com)
        const urlParams = new URLSearchParams(window.location.search);
        const userEmail = urlParams.get("email");
        const userMass: any = urlParams.get("mass") || 0;
        const userMassReqID: any = urlParams.get("reqID") || "";
        if (!userEmail) {
            setMessage("Invalid unsubscribe link.");
            return;
        }

        setEmail(userEmail);

        // Call your unsubscribe API
        if (userMass !== undefined && userMass !== undefined && userMass > 0) {
            unsubscribeForEmail(userEmail, userMass, userMassReqID);
        } else unsubscribeForEmail(userEmail, 0, null);

    }, []);

    return (
        <>
            <Toast ref={toast} />
            <div
                style={{
                    minHeight: "100vh",
                    backgroundColor: "#f8f9fa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "Arial, sans-serif",
                    padding: "20px",
                    textAlign: "center"
                }}
            >
                <div
                    style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #dee2e6",
                        borderRadius: "8px",
                        padding: "40px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
                        maxWidth: "500px",
                        width: "100%"
                    }}
                >
                    <h2 style={{ color: "#dc3545", marginBottom: "20px" }}>Unsubscribe</h2>
                    <p style={{ fontSize: "16px", color: "#212529" }}>{message}</p>
                    {email && (
                        <p style={{ fontSize: "14px", color: "#6c757d", marginTop: "10px" }}>
                            Email: <strong>{email}</strong>
                        </p>
                    )}
                </div>
            </div>
        </>
    );
}